import { render } from "./create_workflow.html?vue&type=template&id=1bdf45d4&external"
import script from "./create_workflow.js?vue&type=script&lang=js&external"
export * from "./create_workflow.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__